import React from "react";
import { Helmet } from "react-helmet-async";
import { HOTEL } from "@/lib/site";

const SITE = "https://regencyinnpittsburg.com";

export function hotelSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Hotel",
    name: HOTEL.name,
    description:
      "Clean, affordable, pet-friendly hotel in Pittsburg, Kansas with free WiFi, free breakfast, extended-stay rates and truck parking near Pittsburg State University.",
    url: SITE,
    telephone: HOTEL.phone,
    email: HOTEL.email,
    image: `${SITE}/assets/hotel/room-1.jpg`,
    priceRange: "$$",
    address: {
      "@type": "PostalAddress",
      streetAddress: HOTEL.address,
      addressLocality: HOTEL.city,
      addressRegion: HOTEL.stateShort,
      postalCode: HOTEL.zip,
      addressCountry: "US",
    },
    geo: { "@type": "GeoCoordinates", latitude: HOTEL.geo.lat, longitude: HOTEL.geo.lng },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: HOTEL.rating,
      reviewCount: HOTEL.reviewCount,
    },
    amenityFeature: [
      "Free WiFi", "Free Breakfast", "Pet Friendly", "Free Parking", "Truck Parking",
      "Business Center", "Laundry", "Extended Stay", "24-Hour Front Desk",
    ].map((n) => ({ "@type": "LocationFeatureSpecification", name: n, value: true })),
  };
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${SITE}${it.path}`,
    })),
  };
}

export function faqSchema(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

export default function Seo({
  title,
  description,
  path = "/",
  image = "/assets/hotel/room-1.jpg",
  schema = [],
  type = "website",
}) {
  const url = `${SITE}${path}`;
  const img = image.startsWith("http") ? image : `${SITE}${image}`;
  const graphs = [hotelSchema(), ...schema];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={HOTEL.name} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {graphs.map((g, i) => (
        <script type="application/ld+json" key={i}>
          {JSON.stringify(g)}
        </script>
      ))}
    </Helmet>
  );
}
